module.exports = __webpack_public_path__ + "static/img/1.46095aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/1/1.png
// module id = wvrk
// module chunks = 0